<script setup lang="ts">
defineProps<{ prefix?: boolean; title?: string }>();
</script>

<template>
  <p>
    {{ prefix ? "Uniboka er en d" : "D" }}igital utgave av grunnboka
    {{ title ? ` ${title}` : "" }} som inkluderer lyd og tilpasser seg skjermen
    på PC, nettbrett og mobil.
    <a href="https://www.unibok.no/om-unibok.html" class="text-current">Les mer om unibok her.</a>
  </p>
</template>
